import RestClient from '../../../../api/axiosInterceptor';

/**
 * Google reCAPTCHA Verification Middleware
 * @param {string} recaptcha_token - The reCAPTCHA token from the frontend
 * @returns {function} - Redux Thunk function
 */
export const pharmacyVerifyCaptcha = (recaptcha_token) => async (dispatch) => {
	try {
		// Dispatch request action
		dispatch({ type: 'VERIFY_RECAPTCHA_REQUEST' });

		// Send the reCAPTCHA token to the backend for validation
		const response = await RestClient.post('/pharmacy/verify-captcha/', {
			recaptcha_token,
		});

		// Dispatch success action with the response
		dispatch({
			type: 'VERIFY_RECAPTCHA_SUCCESS',
			payload: response.data,
		});

		console.log('reCAPTCHA verified successfully!');
	} catch (error) {
		// Handle errors
		const errorMessage =
			error.response?.data?.message || 'reCAPTCHA verification failed.';
		dispatch({
			type: 'VERIFY_RECAPTCHA_FAILURE',
			error: errorMessage,
		});

		console.error('Error during reCAPTCHA verification:', errorMessage, error);
	}
};
